import { useMemo } from "react";

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
];

export const HookUTMParams = () => {
  return useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return UTM_KEYS.reduce((acc, key) => {
      const val = params.get(key);
      if (val) acc[key] = val;
      return acc;
    }, {});
  }, []);
};

export default HookUTMParams;
